import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'utcdate'
})
export class UtcDatePipe implements PipeTransform {

    transform(value: string, format: string): string {
        let momentDate = moment.parseZone(moment(value, moment.ISO_8601));
        if (!momentDate.isValid()) {
            return value;
        }

        switch (format.toLocaleLowerCase())
        {
            case 'defaultdate': 
                return momentDate.format("DD MMM YYYY");
            default:
                return momentDate.format(format);
        }
    }
}